module.exports = __webpack_public_path__ + "img/license_info.6c60a040.svg";